import { Background3 } from '@tanium/react-theme-definition';

export const Background = Background3;
